import { axiosInstance } from './AxiosDefaults';
import { User } from '../models/User';

export const getAllUsers = (): Promise<any> => {
    return axiosInstance.get(
        `/users`,
        {
            withCredentials: false,
            headers: { 'Content-Type': 'application/json' }
        }
    );
};

export const getUser = (id: string): Promise<any> => {
    return axiosInstance.get(
        `${`/users`}/${id}`,
        {
            withCredentials: false,
            headers: { 'Content-Type': 'application/json' }
        }
    );
};

export const createUser = (newUser: User): Promise<any> => {
    return axiosInstance.post(
        '/users',
        newUser,
        {
            headers: { 'Content-Type': 'application/json' }
        }
    );
};

export const updateUser = async (id: string, user: User): Promise<any> => {
    return axiosInstance.put(
        `${'/users'}/${id}`,
        user,
        {
            headers: { 'Content-Type': 'application/json' }
        }
    );
};

export const deleteUser = (id: string): Promise<any> => {
    return axiosInstance.delete(`${'/users'}/${id}`);
};